export default function stringToKey(value) {
    if (value == null) {
        return ''
    }

    // Change to lower case
    const valueLower = value.toLowerCase()
    // Letter "e"
    let slug = valueLower.replace(/[eéèẽẻẹêếềễểệ]/gi, 'e')
    // Letter "a"
    slug = slug.replace(/[aáàãảạăắằẵẳặâấầẫẩậ]/gi, 'a')
    // Letter "o"
    slug = slug.replace(/[oóòõỏọôốồỗổộơớờỡởợ]/gi, 'o')
    // Letter "u"
    slug = slug.replace(/[uúùũủụưứừữửự]/gi, 'u')
    // Letter "d"
    slug = slug.replace(/đ/gi, 'd')
    // Remove special characters (preserve hyphens)
    slug = slug.replace(/[^a-z0-9 -]/gi, '')
    // Trim the last whitespace
    slug = slug.replace(/\s*$/g, '')
    // Change whitespace to "-"
    slug = slug.replace(/\s+/g, '-')
    // Collapse consecutive hyphens into one
    slug = slug.replace(/-+/g, '-')
    // Trim leading and trailing hyphens
    slug = slug.replace(/^-+|-+$/g, '')

    return slug
}
